import React from 'react';
import { useReport, formatReportModuleParams } from '@tencent/dz-report';
export var useReportService = function (_a) {
    var content = _a.content, doctorIndex = _a.doctorIndex;
    var report = useReport();
    var getReportModalParams = function (index) {
        if (index === void 0) { index = doctorIndex; }
        var currentDoctor = content[index];
        return {
            module_id: currentDoctor.id,
            module_value: currentDoctor.name,
            module_type: 'card_doctor_detail_popup',
            module_chinese_type: '医生卡片_详情弹窗',
            element_id: currentDoctor.id,
            element_type: 'card_doctor_detail_popup',
            element_chinese_type: '医生卡片_详情弹窗',
            element_content: currentDoctor.name,
        };
    };
    var reportModuleParams = formatReportModuleParams(getReportModalParams(), {
        element_type: 'card_doctor_detail_popup_reply',
        element_chinese_type: '医生卡片_详情弹窗_立即回复',
    });
    React.useEffect(function () {
        content.forEach(function (doctor) {
            report.exposure({
                module_id: doctor.id,
                module_value: doctor.name,
                module_type: 'card_doctor',
                module_chinese_type: '医生卡片',
                element_id: doctor.id,
                element_type: 'card_doctor',
                element_chinese_type: '医生卡片',
                element_content: doctor.name,
                recommend_mode: doctor.recommendMode,
                ner_mode: doctor.nerMode,
            });
        });
    }, []);
    var doctorModalExposure = function (index) {
        report.exposure(getReportModalParams(index));
    };
    var doctorClick = function (index) {
        var currentDoctor = content[index];
        report.click({
            module_id: currentDoctor.id,
            module_value: currentDoctor.name,
            module_type: 'card_doctor',
            module_chinese_type: '医生卡片',
            element_id: currentDoctor.id,
            element_type: 'card_doctor',
            element_chinese_type: '医生卡片',
            element_content: currentDoctor.name,
            recommend_mode: currentDoctor.recommendMode,
            ner_mode: currentDoctor.nerMode,
        });
    };
    return {
        reportModuleParams: reportModuleParams,
        doctorModalExposure: doctorModalExposure,
        doctorClick: doctorClick,
    };
};
